import React, { useState, useEffect, useRef } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import * as moment from "moment";
import {
  getDatePickerFormat,
  getDateFormat,
  getCalendarLocale,
} from "@utils/datePickerUtils";
import PulseLoader from "react-spinners/PulseLoader";
import { Dialog, Button, Image, Anchor } from "hesus-ui-kit";
import DatePicker from "react-multi-date-picker";
import ClipLoader from "react-spinners/ClipLoader";
import { handleApiError } from "@utils/errorHandler";
import ServiceHeader from "../SiteFollowUp/ServiceHeader";
import CKEditorText from "@components/CKEditorText/CKEditorText";
import closeIcon from "@icons/ic-close-white.svg";
import errorIcon from "@icons/ic-error.svg";
import { SupplierPlanningLineUnit } from "@utils/constants";
import QuoteItems from "./QuoteItems";
import {
  labelStyles,
  labelStylesError,
  RequiredMessagePara,
  RequiredMessage,
} from "@utils/extra-style";
import UserInfo from "@utils/UserInfo";

import {
  HeaderWrapper,
  Title,
  ButtonWrapper,
  FormBody,
  OuterWrapper,
  FlexRow,
  SectionContainer,
  FormErrorDiv,
} from "./Planning.styled";

import {
  RowHeader,
  HeaderWrapperTable,
  EnquiryIdHyphen,
  GridSubLabel,
  EnquiryHeader,
  QuoteInfoAndConditionsInfo,
  GridRow,
} from "../SiteFollowUp/SiteFollowUp.styled";
import "../../SiteView.scss";

const Planning = (props) => {
  const { t, siteId, serviceId, onClose, onRefreshData, orderPlanningDate } =
    props;
  const [isPlanningCreating, setIsPlanningCreating] = useState(false);
  const [createPlanningAPIError, setCreatePlanningAPIError] = useState("");
  const [isRefresh, setIsRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [clientComment, setClientComment] = useState("");

  const [updateCalculation, setUpdateCalculation] = useState(false);
  const [convertUnit, setConvertUnit] = useState(false);
  const [formValidationError, setFormValidationError] = useState("");
  const [data, setData] = useState({});
  // const [formData, setFormData] = useState([]);
  let nextDate = new Date();

  let addDays = 1;
  const currentDay = parseInt(nextDate.getDay(), 10);
  if (currentDay === 5) addDays = 3;
  if (currentDay === 6) addDays = 2;
  nextDate = nextDate.setDate(nextDate.getDate() + addDays);

  const [formData, setFormData] = useState({
    planningDate: {
      required: true,
      value:
        orderPlanningDate !== null
          ? orderPlanningDate
          : moment(nextDate).format("YYYY-MM-DD"),
      error: "",
    },
  });

  const userDetails = UserInfo.getUser();

  const fetchClientOrders = () => {
    setIsLoading(true);
    setButtonDisabled(true);
    axios
      .get(
        `/sites/${siteId}/clientOrders?quoteServiceId=${serviceId}&orderDate=${moment(
          formData.planningDate.value
        ).format("YYYY-MM-DD")}`
      )
      .then((response) => {
        setIsRefresh(false);
        setIsLoading(false);
        setButtonDisabled(false);
        if (response.data?.clientOrder.length > 0) {
          setUpdateCalculation(true);
          setData(response.data?.clientOrder[0]);
        }
        if (response.data?.clientOrder.length > 0) {
          setData(response.data?.clientOrder[0]);
        }
      })
      .catch((error) => handleApiError(error));
  };

  useEffect(() => {
    fetchClientOrders();
  }, [siteId]);

  useEffect(() => {
    if (isRefresh) fetchClientOrders();
  }, [isRefresh]);

  const getExchangePrice = (
    currencyId,
    quoteCurrencyId,
    price,
    exchangeRate
  ) => {
    if (currencyId === quoteCurrencyId) {
      return price;
    }
    const rateInfo = exchangeRate.find(
      (rate) =>
        rate.currencyFrom === currencyId && rate.currencyTo === quoteCurrencyId
    );
    return rateInfo ? rateInfo?.exchangeRate * price : price;
  };

  const onPlanningDateChange = (e) => {
    setFormData({
      ...formData,
      planningDate: {
        value: moment(e.toDate()).format("YYYY-MM-DD"),
        error: "",
        required: true,
      },
    });
    setIsRefresh(true);
  };

  const getClientUnit = (unit) => {
    if (["TON", "M3", "LOAD"].indexOf(unit) !== -1) {
      return "LOAD";
    }
    return unit;
  };

  useEffect(() => {
    if (updateCalculation) {
      let newData = {};
      const items = [];
      if (data?.services?.length > 0) {
        data?.services?.map((service, serviceIndex) => {
          service.serviceItems?.map((item) => {
            const clientOrderExist = service?.clientOrder?.id ? 1 : 0;
            const orderUnit = clientOrderExist
              ? item?.clientOrderItem?.unit
              : getClientUnit(item?.unit);
            items.push({
              id: {
                value: item?.id,
                error: "",
                required: true,
                name: "itemId_" + item.id,
              },
              clientOrderServiceItemId: {
                value: item?.clientOrderItem?.id,
                error: "",
                required: true,
                name: "itemId_" + item.id,
              },
              hesusService: {
                value: item?.hesusService,
                error: "",
                required: true,
                name: "hesusService_" + item.id,
              },
              sellingPrice: {
                value: getExchangePrice(
                  service[serviceIndex]?.currency?.id,
                  data?.quoteCurrency?.id,
                  item?.sellingPrice,
                  data?.exchangeRates
                ),
                error: "",
                required: true,
                name: "sellingPrice_" + item.id,
              },
              label: {
                value: item?.label,
                error: "",
                required: true,
                name: "label_" + item.id,
              },
              product: {
                value: item?.product,
                error: "",
                required: true,
                name: "product_" + item.id,
              },
              transport: {
                value: item?.transport,
                error: "",
                required: true,
                name: "transport_" + item.id,
              },
              quantity: {
                value: clientOrderExist ? item?.clientOrderItem?.quantity : "",
                error: "",
                required: true,
                name: "quantity_" + item.id,
              },
              unit: {
                value: orderUnit,
                error: "",
                required: true,
                name: "unit_" + item.id,
              },
              totalRealised: {
                value: clientOrderExist
                  ? item?.totalRealised -
                    item?.clientOrderItem?.convertedQuantity
                  : item?.totalRealised
                  ? item?.totalRealised
                  : 0,
                error: "",
                required: true,
                name: "totalRealised_" + item.id,
              },
              totalRealisedUnit: {
                value: item?.unit,
                error: "",
                required: true,
                name: "totalRealisedUnit_" + item.id,
              },
              totalRealisedQuantity: {
                value: "",
                error: "",
                required: true,
                name: "totalRealisedQuantity_" + item.id,
              },
              convertedQuantity: {
                value: "",
                error: "",
                required: true,
                name: "convertedQuantity_" + item.id,
              },
              turnOver: {
                value: clientOrderExist
                  ? item?.clientOrderItem?.estimatedTurnover
                  : "-",
                error: "",
                required: true,
                name: "turonOver_" + item.id,
              },
              quoteUnit: item?.unit,
            });
          });
        });
        data?.services?.map((service) => {
          newData = {
            quoteId: data?.quoteId,
            quoteCurrency: data?.quoteCurrency,
            site: data?.site,
            planningDate: {
              required: true,
              value: formData?.planningDate.value,
              error: formData?.planningDate.error,
            },
            services: [
              {
                id: service?.id,
                clientOrder: service?.clientOrder,
                currency: service?.currency,
                sellingPrice: service?.sellingPrice,
                serviceItems: items,
                label: service?.label,
              },
            ],
          };
        });
        setFormData({ ...newData });
        setConvertUnit(true);
        setClientComment(
          data?.services[0]?.clientOrder?.comment
            ? data.services[0].clientOrder?.comment
            : ""
        );
        setUpdateCalculation(false);
      }
    }
  }, [updateCalculation]);

  const getConvertedQuantity = (serviceIndex, itemIndex, item, type) => {
    if (item.transport?.value?.id) {
      const unitData = {
        quantity: item.quantity.value,
        intialUnit: item.unit.value,
        transportTypeId: item.transport?.value?.id,
        finalUnit: item.totalRealisedUnit.value,
      };
      setButtonDisabled(true);
      axios
        .post("/general/convertQuantity", unitData)
        .then((response) => {
          if (type === "update") {
            formData.services[serviceIndex].serviceItems[
              itemIndex
            ].convertedQuantity.value = parseFloat(response.data.quantity);
            formData.services[serviceIndex].serviceItems[
              itemIndex
            ].totalRealisedQuantity.value = (
              parseFloat(response.data.quantity) +
              parseFloat(
                formData.services[serviceIndex].serviceItems[itemIndex]
                  .totalRealised.value
              )
            ).toFixed(2);
            formData.services[serviceIndex].serviceItems[
              itemIndex
            ].turnOver.value = (
              parseFloat(response.data.quantity) *
              parseFloat(item.sellingPrice.value)
            ).toFixed(2);
            setFormData({ ...formData });
            setButtonDisabled(false);
          }
          if (type === "formEdit") {
            formData.services[serviceIndex].serviceItems[
              itemIndex
            ].convertedQuantity.value = parseFloat(response.data.quantity);
            formData.services[serviceIndex].serviceItems[
              itemIndex
            ].totalRealisedQuantity.value = (
              parseFloat(response.data.quantity) +
              formData.services[serviceIndex].serviceItems[itemIndex]
                .totalRealised.value
            ).toFixed(2);
            setFormData({ ...formData });
            setButtonDisabled(false);
          }
        })
        .catch((error) => handleApiError(error));
    } else {
      formData.services[serviceIndex].serviceItems[
        itemIndex
      ].totalRealisedQuantity.value = "?";
      formData.services[serviceIndex].serviceItems[itemIndex].turnOver.value =
        "-";
      setFormData({ ...formData });
      setButtonDisabled(false);
    }
  };

  useEffect(() => {
    if (convertUnit) {
      formData?.services?.map((service, serviceIndex) => {
        service.serviceItems?.map((item, itemIndex) => {
          if (
            item.unit.value === item.totalRealisedUnit.value &&
            (item.quantity.value || item.quantity.value === 0)
          ) {
            formData.services[serviceIndex].serviceItems[
              itemIndex
            ].totalRealisedQuantity.value = (
              parseFloat(item.quantity.value) +
              parseFloat(item.totalRealised.value)
            ).toFixed(2);
            formData.services[serviceIndex].serviceItems[
              itemIndex
            ].convertedQuantity.value = parseFloat(item.quantity.value);
            setFormData({ ...formData });
          }
          if (
            item.unit.value !== item.totalRealisedUnit.value &&
            (item.quantity.value || item.quantity.value === 0) &&
            SupplierPlanningLineUnit.indexOf(item.unit.value) !== -1 &&
            SupplierPlanningLineUnit.indexOf(item.totalRealisedUnit.value) !==
              -1
          ) {
            getConvertedQuantity(serviceIndex, itemIndex, item, "formEdit");
          }
          if (
            item.unit.value !== item.totalRealisedUnit.value &&
            (item.quantity.value || item.quantity.value === 0) &&
            (SupplierPlanningLineUnit.indexOf(item.unit.value) === -1 ||
              SupplierPlanningLineUnit.indexOf(item.totalRealisedUnit.value) ===
                -1)
          ) {
            formData.services[serviceIndex].serviceItems[
              itemIndex
            ].totalRealisedQuantity.value = "?";
            formData.services[serviceIndex].serviceItems[
              itemIndex
            ].convertedQuantity.value = parseFloat(item.quantity.value);
            setFormData({ ...formData });
          }
        });
      });

      setConvertUnit(false);
    }
  }, [convertUnit]);

  const reCalculateData = (serviceIndex, itemIndex) => {
    let isUpdate = false;
    formData?.services?.map((service, sIndex) => {
      service.serviceItems?.map((item, iIndex) => {
        if (sIndex === serviceIndex && itemIndex === iIndex) {
          if (item.quantity.value !== "" && item.unit.value !== "") {
            if (
              item.unit.value === item.totalRealisedUnit.value &&
              (item.quantity.value || item.quantity.value === 0)
            ) {
              formData.services[serviceIndex].serviceItems[
                itemIndex
              ].convertedQuantity.value = parseFloat(item.quantity.value);
              formData.services[serviceIndex].serviceItems[
                itemIndex
              ].totalRealisedQuantity.value = (
                parseFloat(item.quantity.value) +
                parseFloat(item.totalRealised.value)
              ).toFixed(2);
              formData.services[serviceIndex].serviceItems[
                itemIndex
              ].turnOver.value = (
                (item.quantity.value ? parseFloat(item.quantity.value) : 0) *
                parseFloat(
                  getExchangePrice(
                    service?.currency?.id,
                    data?.quoteCurrency?.id,
                    item?.sellingPrice.value,
                    data?.exchangeRates
                  )
                )
              ).toFixed(2);
              isUpdate = true;
            }
            if (
              item.unit.value !== item.totalRealisedUnit.value &&
              (item.quantity.value || item.quantity.value === 0) &&
              (SupplierPlanningLineUnit.indexOf(item.unit.value) === -1 ||
                SupplierPlanningLineUnit.indexOf(
                  item.totalRealisedUnit.value
                ) === -1)
            ) {
              formData.services[serviceIndex].serviceItems[
                itemIndex
              ].convertedQuantity.value = item.quantity.value;
              formData.services[serviceIndex].serviceItems[
                itemIndex
              ].totalRealisedQuantity.value = "?";
              formData.services[serviceIndex].serviceItems[
                itemIndex
              ].turnOver.value = "-";
              isUpdate = true;
            }
            if (
              item.unit.value !== item.totalRealisedUnit.value &&
              (item.quantity.value || item.quantity.value === 0) &&
              SupplierPlanningLineUnit.indexOf(item.unit.value) !== -1 &&
              SupplierPlanningLineUnit.indexOf(item.totalRealisedUnit.value) !==
                -1
            ) {
              getConvertedQuantity(serviceIndex, itemIndex, item, "update");
            }
          }
        }
      });
    });
    if (isUpdate) setFormData({ ...formData });
  };

  const onChange = (e, serviceIndex, itemIndex, type) => {
    const fieldValue = type === "quantity" ? e.target.value : e.value;
    formData?.services?.map((service, sIndex) => {
      service.serviceItems?.map((item, iIndex) => {
        if (sIndex === serviceIndex && itemIndex === iIndex) {
          if (type === "quantity") {
            formData.services[serviceIndex].serviceItems[
              itemIndex
            ].quantity.value = fieldValue;
            formData.services[serviceIndex].serviceItems[
              itemIndex
            ].quantity.error = "";
          }
          if (type === "unit") {
            formData.services[serviceIndex].serviceItems[itemIndex].unit.value =
              fieldValue;
            formData.services[serviceIndex].serviceItems[itemIndex].unit.error =
              "";
          }
        }
      });
    });

    setFormData({ ...formData });
    setFormValidationError("");
    reCalculateData(serviceIndex, itemIndex);
  };

  const validateForm = (dataValidation) => {
    let isFormValid = true;
    dataValidation?.services?.map((service) => {
      service.serviceItems?.map((item) => {
        const clientOrderExist = service?.clientOrder?.id ? 1 : 0;
        if (item.unit.value === "") {
          isFormValid = false;
        }
        if (item.quantity.value === "" && clientOrderExist) {
          isFormValid = false;
        }
        if (
          item.unit.value !== item.totalRealisedUnit.value &&
          (item.quantity.value || item.quantity.value === 0) &&
          (SupplierPlanningLineUnit.indexOf(item.unit.value) === -1 ||
            SupplierPlanningLineUnit.indexOf(item.totalRealisedUnit.value) ===
              -1)
        ) {
          isFormValid = false;
        }
        if (
          item.unit.value !== item.totalRealisedUnit.value &&
          (item.quantity.value || item.quantity.value === 0) &&
          !item.transport?.value?.id &&
          SupplierPlanningLineUnit.indexOf(item.unit.value) !== -1 &&
          SupplierPlanningLineUnit.indexOf(item.totalRealisedUnit.value) !== -1
        ) {
          isFormValid = false;
        }
      });
    });
    if (!isFormValid) {
      setFormValidationError("CLIENT_ORDER_FORM_ERROR");
    } else {
      setFormValidationError("");
    }
    return isFormValid;
  };

  const getFormData = () => {
    const items = [];
    if (formData?.services?.length > 0) {
      formData?.services?.map((service) => {
        service.serviceItems?.map((item) => {
          items.push({
            id: item.id.value,
            clientOrderItem: {
              id: item.clientOrderServiceItemId.value,
              quantity: item.quantity.value ? item.quantity.value : 0,
              unit: item.unit.value,
              convertedQuantity: item.convertedQuantity.value
                ? item.convertedQuantity.value
                : 0,
              estimatedTurnover:
                item.turnOver.value && item.turnOver.value !== "-"
                  ? item.turnOver.value
                  : 0,
              createdBy: userDetails.id,
              updatedBy: userDetails.id,
            },
          });
        });
      });
    }
    const serviceCientOrderData = {
      id: formData?.services[0]?.clientOrder?.id
        ? formData.services[0]?.clientOrder?.id
        : null,
      planningDate: moment(formData.planningDate.value).format(
        "YYYY-MM-DD"
      ),
      createdBy: userDetails.id,
      updatedBy: userDetails.id,
      comment: clientComment,
    };
    const serviceData = formData?.services[0];
    const formSubmitData = {
      quoteId: formData?.quoteId,
      quoteCurrency: formData.quoteCurrency,
      exchangeRates: data.exchangeRates,
      site: data.site,
      services: [
        {
          id: serviceData?.id,
          clientOrder: serviceCientOrderData,
          currency: serviceData?.currency,
          sellingPrice: serviceData?.sellingPrice,
          serviceItems: items,
          label: serviceData?.label,
        },
      ],
    };
    return formSubmitData;
  };
  const onSubmit = () => {
    const isFormValid = validateForm(formData);
    if (isFormValid) {
      const clientOrderId = formData?.services[0]?.clientOrder?.id
        ? formData.services[0]?.clientOrder?.id
        : null;
      setCreatePlanningAPIError("");
      setIsPlanningCreating(true);
      if (!clientOrderId) {
        // for create selling price
        axios
          .post(`/clientOrders`, getFormData())
          .then(() => {
            setIsPlanningCreating(false);
            onRefreshData(true);
            onClose();
          })
          .catch((error) => {
            setIsPlanningCreating(false);
            setCreatePlanningAPIError(error.response?.data?.message ?? "");
          });
      } else {
        // for edit selling price
        axios
          .put(`/clientOrders/${clientOrderId}`, getFormData())
          .then(() => {
            setIsPlanningCreating(false);
            onRefreshData(true);
            onClose();
          })
          .catch((error) => {
            setIsPlanningCreating(false);
            setCreatePlanningAPIError(error.response?.data?.message ?? "");
          });
      }
    }
  };

  return (
    <Dialog width="80rem">
      {/* {!isLoading && ( */}
      <div className="add-edit-enquiry">
        <HeaderWrapper>
          <Title>{"#" + siteId + " - " + data?.site?.name}</Title>
          <Button
            onClick={onClose}
            styles={{
              backgroundColor: "transparent",
              border: "none",
              height: "auto",
              padding: 0,
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <Image
              src={closeIcon}
              alt="close Enquiry price popup"
              className="site-view-enquiry__planning-icon"
            />
          </Button>
        </HeaderWrapper>
        <FormBody>
          <OuterWrapper>
            <FlexRow>
              <SectionContainer>
                <div>
                  <GridRow column="auto 1fr">
                    <div
                      className={
                        formData.planningDate.error
                          ? "add-enquiry__date-container_start_error"
                          : "add-enquiry__date-container_start add-enquiry__date-container_start_required"
                      }
                    >
                      <div>
                        <label htmlFor="winning-date">
                          {t("CLIENT_ORDER_FORM_PLANNING_DATE")}
                        </label>
                      </div>
                      <DatePicker
                        inputClass={
                          formData.planningDate.error
                            ? "add-enquiry__date-input-error"
                            : "add-enquiry__date-input"
                        }
                        containerClassName="add-enquiry__datepicker-container"
                        type="text"
                        label=""
                        name="add-enquiry-start-date"
                        id="add-enquiry-start-date"
                        calendarPosition="bottom-center"
                        isFloat
                        onChange={onPlanningDateChange}
                        format={getDatePickerFormat()}
                        locale={getCalendarLocale()}
                        value={
                          getDateFormat(
                            formData.planningDate.value,
                            "YYYY-MM-DD"
                          ) || ""
                        }
                        containerStyles={{ marginTop: "21px" }}
                        labelStyles={
                          formData.planningDate.error !== ""
                            ? labelStylesError
                            : labelStyles
                        }
                        required
                        error={formData.planningDate.error}
                        placeholder={t("CLIENT_ORDER_FORM_PLANNING_DATE")}
                      />
                      {formData.planningDate.error && (
                        <RequiredMessagePara>
                          {formData.planningDate.error}
                        </RequiredMessagePara>
                      )}
                    </div>
                    {isLoading && (
                      <div className="suggestions-list-loading">
                        <PulseLoader color="#1bace4" size={15} />
                      </div>
                    )}
                  </GridRow>

                  <RowHeader>
                    <GridRow
                      column="40% 20% 25% 15%"
                      marginTop="0px"
                      marginBottom="0px"
                      gridGap="0rem"
                    >
                      <ServiceHeader
                        title="CLIENT_ORDER_FORM_SERVICES"
                        borderRadius="left"
                        align="left"
                      />
                      <ServiceHeader title="CLIENT_ORDER_FORM_ORDER" />
                      <ServiceHeader title="CLIENT_ORDER_FORM_REALISED" />
                      <ServiceHeader
                        title="CLIENT_ORDER_FORM_TURNOVER"
                        borderRadius="right"
                      />
                    </GridRow>
                  </RowHeader>
                  <EnquiryHeader>
                    {formData?.services?.length > 0 &&
                      formData?.services?.map((service, serviceIndex) => {
                        return (
                          <React.Fragment
                            key={
                              "siteFollowup" + service?.sellingPrice?.enquiryId
                            }
                          >
                            <GridRow marginBottom="0px" marginTop="0px">
                              <HeaderWrapperTable color="#3ebbb9">
                                <GridRow
                                  column="auto 80% 1fr"
                                  marginBottom="0px"
                                  marginTop="0px"
                                  gridGap=".5rem"
                                >
                                  <Title
                                    marginTop="6px"
                                    fontWeight="bold"
                                    fontSize="16px;"
                                  >
                                    <Anchor
                                      url={`/site/view/${siteId}/enquiry-view-${service?.sellingPrice?.enquiryId}`}
                                      target="_blank"
                                      className="site-view-enquiry__followup-link"
                                    >
                                      {t("ENQUIRY") +
                                        " #" +
                                        service?.sellingPrice?.enquiryId}
                                    </Anchor>
                                    <EnquiryIdHyphen decoration="none">
                                      {" "}
                                      -{" "}
                                    </EnquiryIdHyphen>
                                  </Title>
                                  <GridSubLabel fontSize="16px">
                                    {service?.label}
                                  </GridSubLabel>
                                </GridRow>
                              </HeaderWrapperTable>
                            </GridRow>
                            <QuoteInfoAndConditionsInfo
                              marginBottom="0px"
                              padding="0px"
                              boxShadow="0px 0px 0px 0px rgba(0,76,127,0.25)"
                            >
                              <QuoteItems
                                itemList={service?.serviceItems}
                                quoteCurrency={formData?.quoteCurrency}
                                onChange={onChange}
                                serviceIndex={serviceIndex}
                                serviceCurrency={service.currency}
                                exchangeRates={data.exchangeRates}
                              />
                            </QuoteInfoAndConditionsInfo>
                          </React.Fragment>
                        );
                      })}
                  </EnquiryHeader>
                  {formValidationError !== "" && (
                    <GridRow column="1fr">
                      <FormErrorDiv>
                        <RequiredMessage>
                          <Image
                            src={errorIcon}
                            alt="warning"
                            className="site-view-enquiry__planning-icon"
                            styles={{ width: "18px !important" }}
                          />{" "}
                          {t(formValidationError)}
                        </RequiredMessage>
                      </FormErrorDiv>
                    </GridRow>
                  )}
                  <GridRow column="1fr">
                    <div className="center-product__title_label">
                      <label htmlFor="center-product">
                        {t("CLIENT_ORDER_FORM_ADDITIONAL_INFO")}
                      </label>
                      <CKEditorText
                        descriptionData={clientComment}
                        setDescriptionData={setClientComment}
                      />
                    </div>
                  </GridRow>
                </div>
              </SectionContainer>
            </FlexRow>
          </OuterWrapper>
        </FormBody>

        <ButtonWrapper>
          {createPlanningAPIError && <div>{createPlanningAPIError}</div>}
          <Button
            styles={{
              color: "white",
              background: "#1BACE4",
              border: "1px solid #1BACE4",
              marginRight: "0.32rem",
              "&:hover": {
                backgroundColor: "#1589b6",
              },
            }}
            disabled={buttonDisabled}
            onClick={onSubmit}
          >
            <>
              {isPlanningCreating && <ClipLoader size={15} color="#fff" />}
              {!isPlanningCreating && t("SUBMIT")}
            </>
          </Button>

          <Button
            styles={{
              color: "#333",
              background: "#fff",
              border: "1px solid #ccc",
              "&:hover": {
                backgroundColor: "#ccc",
              },
            }}
            onClick={onClose}
          >
            {t("CLOSE")}
          </Button>
        </ButtonWrapper>
      </div>
      {/* )} */}
    </Dialog>
  );
};

Planning.propTypes = {
  t: PropTypes.func.isRequired,
  orderPlanningDate: PropTypes.string,
};

Planning.defaultProps = {
  orderPlanningDate: null,
};
export default withTranslation()(Planning);
